<div
  class="input input-date"
  [style.margin-bottom]="messagePad"
  [ngClass]="{ left: labelPositionLeft, 'touched-with-errors': isInvalidDate }"
  [style.width]="width"
>
  <label [for]="name" (click)="onLabelClick($event)" [style.width]="labelWidth"
    >{{ label }}<app-label-icon *ngIf="labelIcon" [data]="labelIcon"
  /></label>
  <div class="calendar-container">
    <p-calendar
      #calendar
      #model="ngModel"
      appReadOnly
      [(ngModel)]="value"
      [dateFormat]="dateFormat"
      [inputId]="name"
      [disabled]="isDisabled"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [placeholder]="placeholder"
      [required]="required"
      [style.width]="inputWidth"
      (onBlur)="onBlur()"
      (onInput)="onInput($event)"
      (onSelect)="onSelect($event)"
      [attr.aria-invalid]="isInvalidDate"
      [attr.aria-describedby]="isInvalidDate ? name + '-error ' + name + '-error2' : null"
      [view]="view"
      [ignoreReadOnly]="ignoreReadOnly"
    ></p-calendar>
    <div class="error-container" *ngIf="isInvalidDate" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
      {{ currentErrorMessage | translateString }}
    </div>
  </div>
  <div
    class="message-container"
    *ngIf="footerMessage && !isInvalidDate"
    [attr.id]="name + '-error2'"
    role="alert"
    aria-atomic="true"
  >
    {{ footerMessage }}
  </div>
</div>
